export default "__VITE_ASSET__91e6f684__"